// extracted by mini-css-extract-plugin
module.exports = {"container":"componentGroup_container__2BQtA","contentContainer":"componentGroup_contentContainer__Ewz_l"};